module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapter_head"
  }, [_c('a', {
    attrs: {
      "id": "ch1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("CHAPTER 1")]), _vm._v(" "), _c('h2', {
    staticClass: "chapter_title"
  }, [_vm._v("All about Pork Chops")]), _vm._v(" "), _c('p', {
    staticClass: "chapter_head_note"
  }, [_vm._v("Pork chops come from the top of the hog in the loin area, and because of that they’re all fairly lean, healthful, tender, and easy to cook. And when cooked properly, pork chops are extremely succulent. The loin of a typical hog is about 18 in/46 cm long, and the cuts vary quite a bit from front to back. In general, the chops from the front of the hog are smaller and well marbled, getting leaner and larger as they head farther back. But in this case, leaner doesn’t mean less flavor. Some may even argue that the lean sirloin chops taste better, with their deep porky flavor and dense texture. The flavor will vary with the thickness of the cut as well. Thick chops are often eaten medium-rare for a juicy, rich, steak-like flavor, while thin chops are typically cooked through, with a firm texture that remains tender just because of the cut. To me, they’re kind of like children. I love them all in their own way. And while they are mostly interchangeable, the better we know these cuts, the better we can choose and cook them properly.")]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('h3', {
    staticClass: "section_head"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("TYPES OF PORK CHOPS")]), _vm._v(" "), _c('p', {
    staticClass: "running_text"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("1")]), _vm._v(" Starting toward the front of the hog, we have the "), _c('strong', [_c('span', {
    staticClass: "red"
  }, [_vm._v("BLADE CHOPS")])]), _vm._v(". These are cut from the beginning of the loin in the shoulder area. They may contain some blade bone as well as back-rib bone. Blade chops are usually cut thicker and are well marbled. These are often butterflied and sold as pork loin country-style ribs. These are well suited to roasting and slow grilling.")]), _vm._v(" "), _c('p', {
    staticClass: "running_text"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("2")]), _vm._v(" Next up are "), _c('span', {
    staticClass: "red"
  }, [_c('strong', [_vm._v("RIBEYE CHOPS")])]), _vm._v(". These originate in the center of the loin in the rib area and may include some back and rib bone. In general, rib chops are the most tender of all pork chops, with the heaviest marbling, and I believe they are the best choice for hot grilling.")]), _vm._v(" "), _c('p', {
    staticClass: "running_text"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("3")]), _vm._v(" Behind the ribeye chops are the "), _c('span', {
    staticClass: "red"
  }, [_c('strong', [_vm._v("PORTERHOUSE CHOPS")])]), _vm._v(". They have that characteristic T-bone shape and are very popular in restaurants because of the look. These chops include a lot of top loin meat as well as a bit of tenderloin meat. They’re called porterhouse chops because of their regal appearance and are well suited to grilling and frying.")]), _vm._v(" "), _c('p', {
    staticClass: "running_text"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("4")]), _vm._v(" Behind the ribeye chops is also the area where we get the "), _c('span', {
    staticClass: "red"
  }, [_c('strong', [_vm._v("NEW YORK CHOP")])]), _vm._v(", also known as the boneless top loin chop. This is a boneless chop cut from the top loin muscle and is what I think of when I hear the term “The Other White Meat.” These lean chops are the most versatile and, while they’re great on the grill when cut 1 in/2.5 cm thick or more, they can be cut thinner too for what I call “breakfast” chops, or easily cut into smaller pieces for use in sandwiches, stews, and casseroles.")]), _vm._v(" "), _c('p', {
    staticClass: "running_text"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("5")]), _vm._v(" Last but not least, bringing up the rear are "), _c('span', {
    staticClass: "red"
  }, [_c('strong', [_vm._v("SIRLOIN CHOPS")])]), _vm._v(". These are cut from the hip area and sometimes include part of the hip bone. They lack a bit in their marbling, but when cooked properly represent a great value with a very meaty pork flavor.")]), _vm._v(" "), _c('div', {
    staticClass: "image_wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "horizontal",
    attrs: {
      "alt": "image",
      "src": "images/f0014-01.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f0887e1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/10chapter01.vue
// module id = 84
// module chunks = 0